import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M2.724 4h26.559l.05.066v23.857l-.058.077H2.725c-.02-.026-.04-.051-.058-.077V4.076L2.724 4Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#1FCE6D",
      fillRule: "evenodd",
      d: "M2.7 4.03 16 16 2.7 27.969l-.034-.046V4.076c.01-.015.022-.03.034-.045Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "m16 2.72-.862.6.304-1.005-.837-.635 1.05-.021L16 .667l.345.992 1.05.021-.837.635.304 1.005-.862-.6Zm-7.333.667-.862.6.304-1.006-.837-.634 1.05-.022.345-.992.345.992 1.05.022-.837.634.304 1.006-.862-.6Zm14.666 0-.862.6.304-1.006-.836-.634 1.05-.022.344-.992.345.992 1.05.022-.837.634.304 1.006-.862-.6ZM16 30.72l-.862.6.304-1.005-.837-.635 1.05-.021.345-.992.345.992 1.05.021-.837.635.304 1.005-.862-.6Zm-7.333-.667-.862.6.304-1.005-.837-.635 1.05-.021.345-.992.345.992 1.05.021-.837.635.304 1.005-.862-.6Zm14.666 0-.862.6.304-1.005-.836-.635 1.05-.021.344-.992.345.992 1.05.021-.837.635.304 1.005-.862-.6Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#1FCE6D",
      fillRule: "evenodd",
      d: "M29.333 4.066v23.857a5.01 5.01 0 0 1-.034.046L16 16 29.304 4.027l.03.039Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M5 16.79c.43.894 1.268 1.868 2 2.21.011-.908-.278-2.073-.673-3L5 16.79Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M4.425 13.924c.507 1.268-1.314 4.292 1.72 5-.374-.613-.616-1.624-.524-2.436.636.29 1.306 1.14 1.577 1.79.794-3.459-2.037-3.248-2.773-4.354.736 1.106 0 0 0 0Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M16 20.667a4.667 4.667 0 1 0 0-9.334 4.667 4.667 0 0 0 0 9.334Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "m16 17.787-2.43 1.69.857-2.833-2.358-1.788 2.96-.06.97-2.796.973 2.796 2.959.06-2.359 1.788.857 2.833-2.43-1.69Z",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagGrd = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagGrd_default = SvgFlagGrd;

export { FlagGrd_default as default };
